import memoize from 'lodash/memoize';

function _memoizeAsyncIterable<T>(iterable: AsyncIterable<T>) {
    const iterator = iterable[Symbol.asyncIterator]();
    const promises: Promise<IteratorResult<T>>[] = [];

    return (index: number) => {
        while (index > promises.length - 1) {
            promises.push(iterator.next());
        }
        return promises[index];
    };
}

export default memoize(_memoizeAsyncIterable) as typeof _memoizeAsyncIterable;
